import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: "The Cat & The Mouse",
  date: new Date(2024, 0, 15),
  img: "/img/beverly-hills.jpeg",
  video: "/videos/beverly-hills.mp4",
  tracks: [
    {
      title: "Side Hustle",
      src: "/songs/2024-01-15/side_hustle.mp3",
      duration: 974.352,
    },
    {
      title: "I'll Go My Way (You Go Yours)",
      src: "/songs/2024-01-15/ill_go_my_way.mp3",
      duration: 692.688,
    },
    {
      title: "Haunted Horsepower",
      src: "/songs/2024-01-15/haunted_horsepower.mp3",
      duration: 978.216,
    },
    {
      title: "Pryzum",
      src: "/songs/2024-01-15/pryzum.mp3",
      duration: 623.016,
    },
    {
      title: "New Shoes",
      src: "/songs/2024-01-15/new_shoes.mp3",
      duration: 1005.504,
    },
    {
      title: "Almost Tomorrow",
      src: "/songs/2024-01-15/almost_tomorrow.mp3",
      duration: 1102.944,
    },
    {
      title: "Cool Little Place",
      src: "/songs/2024-01-15/cool_little_place.mp3",
      duration: 689.88,
    },
    {
      title: "Disolving Into Ectoplasm",
      src: "/songs/2024-01-15/disolving_into_ectoplasm.mp3",
      duration: 1154.472,
    },
    {
      title: "Pissin' In The Pool",
      src: "/songs/2024-01-15/pissin_in_the_pool.mp3",
      duration: 997.152,
    },
  ],
};
export default album;
